module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.edc3ba63.png";